import { useEffect, useState } from "react";
import { publicGet } from "../lib/api";
import { Card, CardTitle } from "../components/ui/Card";
import { DataState } from "../components/ui/DataState";

interface Resource {
  slug: string;
  title: string;
  summary: string;
}

export default function Resources() {
  const [resources, setResources] = useState<Resource[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    publicGet<{ resources: Resource[] }>("/api/resources")
      .then((r) => {
        setResources(r.resources);
        setError(null);
      })
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-page py-12">
      <header>
        <h1 className="text-3xl font-semibold text-white">Safety resources</h1>
        <p className="mt-2 max-w-3xl text-slate-300">
          Practical, calm guidance for community members, business owners,
          churches, schools, and neighborhood organizations. We will keep
          adding to this library — submit ideas via your platform admin.
        </p>
      </header>

      <div className="mt-8">
        <DataState
          loading={loading}
          error={error}
          data={resources}
          empty={!!resources && resources.length === 0}
          loadingMessage="Loading safety resources…"
          emptyMessage="No resources available yet."
        >
          {(items) => (
            <div className="grid gap-5 md:grid-cols-2">
              {items.map((r) => (
                <Card key={r.slug}>
                  <CardTitle className="text-lg">{r.title}</CardTitle>
                  <p className="mt-2 text-slate-300">{r.summary}</p>
                  <p className="mt-4 text-xs text-slate-400">
                    Full guide coming soon.
                  </p>
                </Card>
              ))}
            </div>
          )}
        </DataState>
      </div>
    </div>
  );
}
